/* eslint-env browser */
import * as React from 'react'

import { extractArticleFullName } from '../../../../../../shared/services/gear-service'

const { replaceStorageByCdn } = require('../../../../../../shared/services/media-helper')

const PropTypes = require('prop-types')

class LargeGearItem extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { gear, productCategory = {} } = this.props

    let imgUrl = replaceStorageByCdn(gear.mediaUrl_300 || gear.mediaUrl_600 || gear.mediaUrl)
    if (!imgUrl) {
      if (productCategory && productCategory.icon) {
        imgUrl = productCategory.icon.url_300
      }
    }
    const fullName = extractArticleFullName({
      productName: gear.productName,
      modelName: gear.productModelName,
      articleName: gear.productArticleName,
    })

    return (
      <div className="is-size-7-mobile content-card is-full-height">
        <a
          href={`/gear/products/${gear.productSeoName}?pa=${gear.productArticleSeoName}`}
          title={`${productCategory.name} ${gear.brandName} ${fullName}`.trim()}
        >
          <figure className="image is-2by1">
            <img
              src={imgUrl}
              className="has-object-fit-contain"
              alt={`${productCategory.name} ${gear.brandName} ${fullName}`.trim()}
              title={`${productCategory.name} ${gear.brandName} ${fullName}`.trim()}
            />
          </figure>
        </a>
        <div className="title is-8 has-text-weight-bold has-text-primary-blue has-text-centered is-uppercase">
          <a href={`/gear/brands/${gear.brandSeoName}`}>{gear.brandName}</a>
        </div>
        <div className="subtitle is-8 is-uppercase has-text-centered">
          <a
            href={`/gear/products/${gear.productSeoName}?pa=${gear.productArticleSeoName}`}
            title={`${productCategory.name} ${gear.brandName} ${fullName}`.trim()}
          >
            {fullName}
          </a>
        </div>
      </div>
    )
  }
}

LargeGearItem.propTypes = {
  gear: PropTypes.object.isRequired,
  productCategory: PropTypes.object,
}

LargeGearItem.defaultProps = {
  productCategory: {},
}

module.exports = LargeGearItem
